const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	FormTokenField,
	TextControl,
	SelectControl,
	ToggleControl,
	PanelBody,
	Disabled,
	Placeholder
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
const { withSelect } = wp.data;
const { createElement: el } = wp.element;
import icons from "../../../icons.js";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/listing", {
	title: __("Listing", "wp-apidae"), // Block title.
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.listing
	},
	supports: {
    align: ['full','wide'],
  },
	attributes: {
		selection: {
			type: "number",
			default: 0,
		},
		modele: {
			type: "string",
		},
		columns: {
			type: "number",
			default: 2,
		},
		limit: {
			type: "number",
			default: 20,
		},
		is_agenda: {
			type: "boolean",
			default: false,
		},
		pagination: {
			type: "boolean",
			default: false,
		},
		orders_filter: {
      type: "array",
      default: [],
    },
		align: {
			type: 'string',
			default: '',
		},
	},
	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;
			const selections = window.WpApidaeTemplateData.selections;

			/**
     * Order results by criteres internes
     */
			 const OrderFilter = withSelect((select) => {
				const { isResolving } = select("core/data");
				return {
					taxonomies: select("core").getEntityRecords(
						"taxonomy",
						"at_criteresinternes",
						{ per_page: -1 }
					),
					isRequesting: isResolving("core", "getEntityRecords", [
						"taxonomy",
						"at_criteresinternes",
						{ per_page: -1 }
					]),
				};
			})((props) => {
				if (props.isRequesting) {
					// still resolving; so display a "loading" indicator
					return el("div", null, "Chargement des critères internes...");
				} else {
					if ( null === props.taxonomies ) {
						return el("div", null, "Chargement des critères internes...");
					}
					let taxoNames = [];
					let taxosFieldValue = [];
	
					taxoNames = props.taxonomies.map( (taxo) => taxo.name );
					taxosFieldValue = attributes.orders_filter.map( ( taxoID ) => {
						let wantedTaxo = props.taxonomies.find( ( taxo ) => {
							return taxo.slug === taxoID;
						} );
						if ( wantedTaxo === undefined || ! wantedTaxo ) {
							return false;
						}
						return wantedTaxo.name;
					} );
					return (
						<FormTokenField
							value={taxosFieldValue}
							suggestions={taxoNames}
							onChange={ ( orders_filter ) => {
								let selectedTaxosArray = [];
								orders_filter.map(
									( taxoName ) => {
										const matchingTaxo = props.taxonomies.find( ( taxo ) => {
											return taxo.name === taxoName;
										} );
										if ( matchingTaxo !== undefined ) {
											selectedTaxosArray.push( matchingTaxo.slug )
										}
									}
								)
								this.props.setAttributes( { orders_filter: selectedTaxosArray } );
							} }
							placeholder={__("Ajouter un critère", "wp-apidae")}
							label={__(
								"Ordonner les résultats par critères internes",
								"wp-apidae"
							)}
						/>
					);
				}
			});

			return [
				props.isSelected && (
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("General")}>
							<SelectControl
								label={__("Sélection")}
								value={attributes.selection}
								options={selections}
								onChange={(newValue) => {
									props.setAttributes({
										selection: Number(newValue),
									});
								}}
							/>
							<TextControl
								type="number"
								label={__("Nombre de colonnes")}
								value={attributes.columns}
								min={`1`}
								max={`3`}
								onChange={(newValue) => {
									props.setAttributes({ columns: Number(newValue) });
								}}
							/>
							<TextControl
								type="number"
								label={__("Fiches par page")}
								value={attributes.limit}
								min={`1`}
								max={`1000`}
								onChange={(newValue) => {
									props.setAttributes({ limit: Number(newValue) });
								}}
							/>
							<ToggleControl
								label={ __( 'Classer par date' ) }
								checked={ attributes.is_agenda }
								onChange={ () => {
									props.setAttributes({ is_agenda: ! attributes.is_agenda });
								} }
							/>
							<ToggleControl
								label={ __( 'Afficher la pagination' ) }
								checked={ attributes.pagination }
								onChange={ () => {
									props.setAttributes({ pagination: ! attributes.pagination });
								} }
							/>
						</PanelBody>
						<PanelBody title="Configuration avancée" initialOpen={false}>
							{el(OrderFilter)}
						</PanelBody>
					</InspectorControls>
				),
				<> 
				{ 0 === attributes.selection &&
					<Placeholder
					icon={icons.base}
					label={__("Listing de sélection", "wp-apidae")}
				>
					<SelectControl
								label={__("Sélection à afficher")}
								value={attributes.selection}
								options={selections}
								onChange={(newValue) => {
									props.setAttributes({
										selection: Number(newValue),
									});
								}}
							/>
				</Placeholder>
					}
					{ 0 !== attributes.selection &&
						<Disabled>
						<ServerSideRender block="wp-apidae/listing" attributes={attributes} />
					</Disabled>
						}
						</>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
